import React, { useEffect, useState, useRef } from "react";
import { Typography, Row, Col, Card, Button, Collapse, Switch, InputNumber, Layout } from "antd";
import {
    CheckOutlined,
    TagFilled,
    FireOutlined,
    UpOutlined,
    DownOutlined,
    ArrowRightOutlined,
    ArrowLeftOutlined,
} from "@ant-design/icons";
import "./OfferingCarousel.scss";
import "../../../App.scss"
import Slider from "react-slick"
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { PORTAL_BASE_URL } from "../../../env";
import { AnimatePresence, motion } from "framer-motion";
import ModelViewer from "../../landingPage/sectionTwo/modelViewer";
import QRCode from "react-qr-code";

const { Content } = Layout;
const qrUrl = `https://d1rzyeqsmooian.cloudfront.net/ar-viewer/32064?platform=google&env=production`;

const terms = [
    'Amazon',
    'Shopify',
    'custom',
    'social',
    'Etsy'
]

const offerings = [
    {
        model: true,
        poster: "https://storage.googleapis.com/all3d/product_assets/perspective_renders/32064_FrontAngled.jpg",
        src: "https://storage.googleapis.com/all3d/product_assets/glb/32064.glb",
    },
    {
        img: 'https://d48f7equ64qjl.cloudfront.net/static_files/homepage_assets/lip_care.jpg',
    },
    {
        ai: true,
        img: 'https://d48f7equ64qjl.cloudfront.net/static_files/homepage_assets/sdf.png'
    },

    {
        model: true,
        poster: "https://storage.googleapis.com/all3d/product_assets/perspective_renders/31115_FrontAngled.jpg",
        src: "https://storage.googleapis.com/all3d/product_assets/glb/31115.glb",
    },
    {
        img: 'https://d48f7equ64qjl.cloudfront.net/static_files/homepage_assets/handbag.jpg'
    },

    {
        ai: true,
        img: 'https://d48f7equ64qjl.cloudfront.net/static_files/homepage_assets/VR.png'
    },
    {
        model: true,
        poster: "https://storage.googleapis.com/all3d/product_assets/perspective_renders/31003_FrontAngled.jpg",
        src: "https://storage.googleapis.com/all3d/product_assets/glb/31003.glb",
    },
    {
        img: 'https://d48f7equ64qjl.cloudfront.net/static_files/homepage_assets/tent.png'
    },
    {
        ai: true,
        img: 'https://d48f7equ64qjl.cloudfront.net/static_files/homepage_assets/lifestyle_3_512.jpg'
    },
    {
        model: true,
        poster: "https://storage.googleapis.com/all3d/product_assets/perspective_renders/54025_FrontAngled.jpg",
        src: "https://storage.googleapis.com/all3d/product_assets/glb/54025.glb",
    },
    {
        img: 'https://d48f7equ64qjl.cloudfront.net/static_files/homepage_assets/living-room.jpg'
    },
    {
        ai: true,
        img: 'https://d48f7equ64qjl.cloudfront.net/static_files/homepage_assets/lifestyle_2_512.jpg'
    },


]

const OfferingCarousel = () => {
    return (
        <>
            <WebVersion />
            <MobileVersion />
        </>
    )

}

const WebVersion = () => {
    const [index, setIndex] = useState(0);
    const [width, setWidth] = useState(0);
    const [firstScroll, setFirstScroll] = useState(true);
    const [isDraggingEnabled, setIsDraggingEnabled] = useState(true);

    const measureRef = useRef();
    let sliderRef = useRef(null);

    const handleBeforeChange = (oldIndex, newIndex) => {
        console.log("Swipe detected from", oldIndex, "to", newIndex);
        setFirstScroll(false);
    };

    // Cycle through the words
    useEffect(() => {
        const interval = setInterval(() => {
            setIndex((prev) => (prev + 1) % terms.length);
        }, 2000); // Change word every 1 second
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        if (measureRef.current) {
            setWidth(measureRef.current.offsetWidth);
        }
    }, [index]);

    let settings = {
        autoplay: false,
        dots: false,
        infinite: true,
        arrows: false,
        speed: 600,
        slidesToShow: 4,
        slidesToScroll: 4,
        vertical: false,
        beforeChange: handleBeforeChange

    };


    const next = () => {
        setFirstScroll(false);
        if (sliderRef) {
            sliderRef.slickNext();
        }
    };

    const prev = () => {
        if (sliderRef) {
            sliderRef.slickPrev();
        }
    };



    return (
        <Content className="d-none d-lg-block">
            <Row className="container-fluid offering-carousel-wrapper">
                <Row className="section-margin-right w-100 direction-flex justify-space-between mb-80">
                    <Col span={15}>
                        <div
                            className="manrope f-50 w-600 lh-60 white text-left"
                            style={{ display: "inline-block" }}>
                            3D imagery of any product for your{" "}
                            <span
                                ref={measureRef}
                                className="manrope f-50 w-600 lh-60 blue hide-word">
                                {terms[index]}
                            </span>
                            <motion.span
                                layout
                                transition={{ layout: { duration: 0.3, ease: "easeInOut" } }}
                                style={{ display: "inline-block" }}>
                                <span
                                    className="word-container-settings"
                                    style={{
                                        width: `${width + 10}px`
                                    }}>
                                    <AnimatePresence>
                                        <motion.span
                                            key={terms[index]}
                                            initial={{ y: 30, opacity: 0 }}
                                            animate={{ y: 0, opacity: 1 }}
                                            exit={{ y: -30, opacity: 0 }}
                                            transition={{
                                                duration: 0.5,
                                            }}
                                            className="manrope f-50 w-600 lh-60 blue word-settings">
                                            {terms[index]}
                                        </motion.span>
                                    </AnimatePresence>
                                </span>{" "}
                                storefronts
                            </motion.span>
                        </div>
                    </Col>
                    <Col span={6}>
                        <div className="manrope f-16 w-500 lh-24 white text-left">
                            API integration of 3D models, product and lifestyle images, AR view in room, and even unlimited AI images of your product.
                        </div>
                    </Col>
                </Row>
                <Col span={24} className="mb-24">
                    <Slider ref={slider => {
                        sliderRef = slider;
                    }} {...settings} className="offering-slider-setting">
                        {offerings.map((offering) => (
                            <Card className="offering-card" bordered={false}>
                                {offering.ai ? <div className="ai-tag-pos ai-tag">
                                    <div className="manrope f-12 lh-20 blue-gradient w-600">AI</div>
                                </div> : ''}

                                {offering.model ?
                                    <div className="offering-model-container">
                                        <ModelViewer class='offering-model'
                                            poster={offering.poster}
                                            src={offering.src}
                                        />
                                    </div> :
                                    <img loading="lazy" src={offering.img} className={`offering-img-dim`}
                                    />}
                            </Card>
                        ))}
                    </Slider>
                </Col>
                <Row className="section-margin-right w-100">
                    <Col span={12} className="direction-flex roww justify-in-start">
                        <Card bordered={false} className="qr-card mr-24">
                            <QRCode value={qrUrl} className="qr-card-img" />
                        </Card>
                        <p className="manrope f-16 w-500 lh-24 white mb-0 mr-8">Scan QR code to try AR View in Room</p>
                        <img src="/new_homepage/ar_icon.svg" />
                    </Col>
                    <Col span={12} className="direction-flex roww justify-in-end">
                        <Button onClick={prev}
                            icon={<ArrowLeftOutlined className="manrope f-20 lh-0" />}
                            className={`slider-btn-ar ${firstScroll ? `disabled` : ``} mr-24`}
                        />
                        <Button onClick={next}
                            icon={<ArrowRightOutlined className="manrope f-20 lh-0" />}
                            className={`slider-btn-ar`}
                        />
                    </Col>
                </Row>
            </Row>
        </Content>
    )
}

const MobileVersion = () => {
    const [index, setIndex] = useState(0);
    const [width, setWidth] = useState(0);
    const measureRef = useRef();
    let sliderRef = useRef(null);

    // Cycle through the words
    useEffect(() => {
        const interval = setInterval(() => {
            setIndex((prev) => (prev + 1) % terms.length);
        }, 2000); // Change word every 1 second
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        if (measureRef.current) {
            setWidth(measureRef.current.offsetWidth);
        }
    }, [index]);

    const settings = {
        autoplay: false,
        dots: false,
        infinite: true,
        arrows: false,
        speed: 600,
        slidesToShow: 1.03,
        slidesToScroll: 1,
        vertical: false,
        initialSlide: 0
    };

    const [isWide, setIsWide] = useState(window.innerWidth > 500);

    useEffect(() => {
        const handleResize = () => {
            setIsWide(window.innerWidth > 500);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const Wrapper = isWide ? "span" : "div";

    return (
        <Content className="d-lg-none">
            <Row className="container-fluid offering-carousel-wrapper">
                <Row className="section-margin-right w-100 direction-flex justify-space-between mb-24">
                    <Col span={24} className='mb-16'>
                        <div
                            className="manrope f-38 w-600 lh-46 white text-left"
                            style={{ display: "inline-block" }}>
                            3D imagery of any product for your{" "}
                            <span
                                ref={measureRef}
                                className="manrope f-38 w-600 lh-46 blue hide-word">
                                {terms[index]}
                            </span>

                            <span
                                className="word-container-settings"
                                style={{
                                    width: `${width + 10}px`
                                }}>
                                <AnimatePresence>
                                    <motion.span
                                        key={terms[index]}
                                        initial={{ y: 30, opacity: 0 }}
                                        animate={{ y: 0, opacity: 1 }}
                                        exit={{ y: -30, opacity: 0 }}
                                        transition={{
                                            duration: 0.5,
                                        }}
                                        className="manrope f-38 w-600 lh-46 blue word-settings">
                                        {terms[index]}
                                    </motion.span>
                                </AnimatePresence>
                            </span>
                            <Wrapper>storefronts</Wrapper>

                        </div>
                    </Col>
                    <Col span={24}>
                        <div className="manrope f-16 w-500 lh-24 white text-left mb-24">
                            API integration of 3D models, product and lifestyle images, AR view in room, and even unlimited AI images of your product.
                        </div>
                    </Col>
                </Row>
                <Col span={24} className="mb-24">
                    <Slider ref={slider => {
                        sliderRef = slider;
                    }} {...settings} className="offering-slider-setting">
                        {offerings.map((offering, index) => (
                            <Card className="offering-card" key={index} bordered={false}>
                                {offering.ai ? <div className="ai-tag-pos ai-tag">
                                    <div className="manrope f-12 lh-20 blue-gradient w-600">AI</div>
                                </div> : ''}
                                {offering.model ?
                                    <div className="offering-model-container">
                                        <ModelViewer class='offering-model'
                                            poster={offering.poster}
                                            src={offering.src}
                                        />
                                    </div> :
                                    <img loading="lazy" src={offering.img} className={`offering-img-dim`} />}
                            </Card>
                        ))}
                    </Slider>
                </Col>
                <Row className="section-margin-right w-100">
                    <Col span={24} className="direction-flex roww justify-in-center">
                        <img src="/new_homepage/ar_icon.svg" />
                        <a className="manrope f-16 w-500 lh-24 white mb-0 ml-8" href={qrUrl}>Try AR View in Room</a>
                    </Col>

                </Row>
            </Row>
        </Content>
    )
}

export default OfferingCarousel;
